export default __webpack_public_path__ + "static/media/instagram_icon_white.6d07f5a5.svg";